import { render } from "./Info.vue?vue&type=template&id=20dcebd9&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=20dcebd9&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\wkt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dcebd9"]])

export default __exports__